import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { LearnerFormResponse, LearnerFormUpdateRequest } from "@eduviaos/shared";
import { api } from "@/lib/api";

/**
 * Phase SC-22 — the tenant's resolved team invite form (`GET /me/team-form`).
 *
 * The wire shape matches the learner form so both settings pages share
 * `LearnerFormEditor`. The backend merges vertical defaults with overrides.
 */
export const teamFormKeys = {
  all: ["team-form"] as const,
  me: () => [...teamFormKeys.all, "me"] as const,
};

export function useTeamForm(options: { enabled?: boolean } = {}) {
  return useQuery<LearnerFormResponse>({
    queryKey: teamFormKeys.me(),
    queryFn: () => api.get<LearnerFormResponse>("/me/team-form"),
    staleTime: 5 * 60_000,
    enabled: options.enabled ?? true,
  });
}

export function useUpdateTeamForm() {
  const qc = useQueryClient();
  return useMutation<LearnerFormResponse, Error, LearnerFormUpdateRequest>({
    mutationKey: ["team-form", "update"],
    mutationFn: (body) => api.put<LearnerFormResponse>("/me/team-form", body),
    onSuccess: (form) => {
      qc.setQueryData(teamFormKeys.me(), form);
    },
  });
}
